import { FormEvent, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import Notiflix from 'notiflix'
import { FaArrowRight, FaSearch } from 'react-icons/fa'
import { Button, Card, colors, Field, Input } from '../../../../ui'
import styles from '../styles.module.scss'

const isValidEmail = (value: string) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)
const isValidUKPhone = (value: string) => /^\+44\d{9,10}$/.test(value.replace(/\s+/g, ''))

export const ClientSearchSection = () => {
    const navigate = useNavigate()
    const [email, setEmail] = useState('')
    const [phone, setPhone] = useState('')

    const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
        event.preventDefault()
        const trimmedEmail = email.trim()
        const trimmedPhone = phone.trim()

        if (!trimmedEmail && !trimmedPhone) {
            Notiflix.Report.failure(
                'Search Required',
                'Please enter an email or phone number to search.',
                'OK',
            )
            return
        }

        if (trimmedEmail && !isValidEmail(trimmedEmail)) {
            Notiflix.Report.failure(
                'Invalid Email',
                'Please check the email address and try again.',
                'OK',
            )
            return
        }

        if (trimmedPhone && !isValidUKPhone(trimmedPhone)) {
            Notiflix.Report.failure(
                'Invalid Phone Number',
                'Use a UK number including +44 (e.g. +447123456789).',
                'OK',
            )
            return
        }

        const params = new URLSearchParams()
        if (trimmedEmail) params.set('email', trimmedEmail)
        if (trimmedPhone) params.set('phone', trimmedPhone)
        navigate(`/client-search?${params.toString()}`)
    }

    return (
        <Card
            as="section"
            title={
                <>
                    <FaSearch style={{ color: colors.ink4, fontSize: 13 }} /> Client Search
                </>
            }
            subtitle="Jump straight into the full client search by entering an email or phone number."
        >
            <form className={styles.searchForm} onSubmit={handleSubmit}>
                <div className={styles.searchInputs}>
                    <Field label="Client Email" className={styles.inputGroup}>
                        {(id) => (
                            <Input
                                id={id}
                                type="email"
                                value={email}
                                onChange={(event) => setEmail(event.currentTarget.value)}
                                placeholder="client@example.com"
                                autoComplete="off"
                            />
                        )}
                    </Field>
                    <div className={styles.orSeparator}>OR</div>
                    <Field label="Phone (UK, +44)" className={styles.inputGroup}>
                        {(id) => (
                            <Input
                                id={id}
                                type="tel"
                                value={phone}
                                onChange={(event) => setPhone(event.currentTarget.value)}
                                placeholder="+447123456789"
                                autoComplete="off"
                            />
                        )}
                    </Field>
                </div>
                <div className={styles.searchActions}>
                    <Button type="submit" variant="primary" icon={<FaSearch />}>
                        Search Clients
                    </Button>
                    <Button type="button" iconRight={<FaArrowRight />} onClick={() => navigate('/client-search')}>
                        Open full search
                    </Button>
                </div>
            </form>
        </Card>
    )
}
